export default __webpack_public_path__ + "static/media/inventMgmt4.3e462506.png";